<template>
    <div class="o-highlights" id="highlights">
        <home-button :location="'desktop'"></home-button>
        <router-view :key="$route.fullPath"></router-view>
        <preview-next format="lg"></preview-next>
        <back-button></back-button>
        <timeline></timeline>
        <background-container></background-container>
        <mob-nav></mob-nav>
    </div>
</template>

<script>
export default {
    data: function() {
        return {
            touch_start_x: 0,
            touch_start_y: 0,
            touch_end_x: 0,
            touch_end_y: 0,
        }
    },
    mounted() {

        const hl = document.getElementById('highlights');

        hl.addEventListener('touchstart', ( event ) => {
            this.touch_start_x = event.changedTouches[0].screenX;
            this.touch_start_y = event.changedTouches[0].screenY;
        }, false);
                
        hl.addEventListener('touchend', ( event ) => {
            this.touch_end_x = event.changedTouches[0].screenX;
            this.touch_end_y = event.changedTouches[0].screenY;
            this._handleGesture();
        }, false);

        this.dataLayerPush({
            "event": "highlight_view",
            "highlight_name": this.$route.meta.title,
        });
    },
    methods: {
        _handleGesture: function() {
            if( ( this.touch_end_x <= this.touch_start_x ) && ( this.touch_end_y >= ( 0.85 * this.touch_start_y ) && this.touch_end_y <= ( 1.15 * this.touch_start_y ) ) ) {
                /* eslint-disable */
                this.swipeLeft();
            } else if( ( this.touch_end_x >= this.touch_start_x ) && ( this.touch_end_y >= ( 0.85 * this.touch_start_y ) && this.touch_end_y <= ( 1.15 * this.touch_start_y ) ) ) {
                /* eslint-disable */
                this.swipeRight();
            }
        }
    }
}
</script>

<style lang="scss">
    @import "../styles/global.scss";
</style>